import '@angular/compiler';
import { PortalLpsysadminCollabCalendarComponent } from './portal.lpsysadmin.collab.calendar/portal.lpsysadmin.collab.calendar.component';
import { PortalLpsysadminBoardListComponent } from './portal.lpsysadmin.board.list/portal.lpsysadmin.board.list.component';
import { PageSupportApplyComponent } from './page.support.apply/page.support.apply.component';
import { PageJoinComponent } from './page.join/page.join.component';
import { PortalLpsysWidgetPdfviewerComponent } from './portal.lpsys.widget.pdfviewer/portal.lpsys.widget.pdfviewer.component';
import { PageCompanyItemComponent } from './page.company.item/page.company.item.component';
import { PageApplyHomeComponent } from './page.apply.home/page.apply.home.component';
import { PortalLpsysadminCollabNotificationComponent } from './portal.lpsysadmin.collab.notification/portal.lpsysadmin.collab.notification.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalLpsysadminCollabMyworkComponent } from './portal.lpsysadmin.collab.mywork/portal.lpsysadmin.collab.mywork.component';
import { PortalLpsysadminWidgetCompanyEditorComponent } from './portal.lpsysadmin.widget.company.editor/portal.lpsysadmin.widget.company.editor.component';
import { PagePublicProgramsComponent } from './page.public.programs/page.public.programs.component';
import { PortalLpsysadminComplianceChecklistModuleComponent } from './portal.lpsysadmin.compliance.checklist.module/portal.lpsysadmin.compliance.checklist.module.component';
import { PortalLpsysadminSupportProgramItemComponent } from './portal.lpsysadmin.support.program.item/portal.lpsysadmin.support.program.item.component';
import { PortalLpsysFundItemComponent } from './portal.lpsys.fund.item/portal.lpsys.fund.item.component';
import { PortalLpsysMyprofileDeductionComponent } from './portal.lpsys.myprofile.deduction/portal.lpsys.myprofile.deduction.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageLogoutComponent } from './page.logout/page.logout.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalLpsysadminUserListComponent } from './portal.lpsysadmin.user.list/portal.lpsysadmin.user.list.component';
import { PortalLpsysadminCollabBoardItemComponent } from './portal.lpsysadmin.collab.board.item/portal.lpsysadmin.collab.board.item.component';
import { PortalLpsysFundListOperatingComponent } from './portal.lpsys.fund.list.operating/portal.lpsys.fund.list.operating.component';
import { PortalLpsysadminWidgetMessageSendComponent } from './portal.lpsysadmin.widget.message.send/portal.lpsysadmin.widget.message.send.component';
import { PortalLpsysadminCollabTaskComponent } from './portal.lpsysadmin.collab.task/portal.lpsysadmin.collab.task.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { LayoutApplyComponent } from './layout.apply/layout.apply.component';
import { PortalLpsysadminFundListExitComponent } from './portal.lpsysadmin.fund.list.exit/portal.lpsysadmin.fund.list.exit.component';
import { PortalLpsysadminWidgetCompanyProductComponent } from './portal.lpsysadmin.widget.company.product/portal.lpsysadmin.widget.company.product.component';
import { PortalLpsysadminWidgetNotionPageComponent } from './portal.lpsysadmin.widget.notion.page/portal.lpsysadmin.widget.notion.page.component';
import { PageSupportManageComponent } from './page.support.manage/page.support.manage.component';
import { PageFindpwComponent } from './page.findpw/page.findpw.component';
import { PageMentoringSessionComponent } from './page.mentoring.session/page.mentoring.session.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalLpsysadminWidgetCompanyInvestmentComponent } from './portal.lpsysadmin.widget.company.investment/portal.lpsysadmin.widget.company.investment.component';
import { PortalLpsysadminWidgetFundInfoComponent } from './portal.lpsysadmin.widget.fund.info/portal.lpsysadmin.widget.fund.info.component';
import { PortalLpsysadminCompanyReportComponent } from './portal.lpsysadmin.company.report/portal.lpsysadmin.company.report.component';
import { PortalLpsysadminWidgetCompanyLogComponent } from './portal.lpsysadmin.widget.company.log/portal.lpsysadmin.widget.company.log.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageInvestmentCommitteeComponent } from './page.investment.committee/page.investment.committee.component';
import { PortalLpsysadminCompanyItemComponent } from './portal.lpsysadmin.company.item/portal.lpsysadmin.company.item.component';
import { PageMentorComponent } from './page.mentor/page.mentor.component';
import { PageMyProgramItemComponent } from './page.my.program.item/page.my.program.item.component';
import { PortalLpsysadminSupportModuleDiagnosisComponent } from './portal.lpsysadmin.support.module.diagnosis/portal.lpsysadmin.support.module.diagnosis.component';
import { PortalLpsysadminSupportEvaluatorsComponent } from './portal.lpsysadmin.support.evaluators/portal.lpsysadmin.support.evaluators.component';
import { PageExpertProgramsComponent } from './page.expert.programs/page.expert.programs.component';
import { PortalLpsysadminSupportFormListComponent } from './portal.lpsysadmin.support.form.list/portal.lpsysadmin.support.form.list.component';
import { PortalLpsysadminWidgetCompanyOverviewComponent } from './portal.lpsysadmin.widget.company.overview/portal.lpsysadmin.widget.company.overview.component';
import { PortalLpsysadminSupportModuleEducationComponent } from './portal.lpsysadmin.support.module.education/portal.lpsysadmin.support.module.education.component';
import { PortalLpsysCommunityViewComponent } from './portal.lpsys.community.view/portal.lpsys.community.view.component';
import { PortalLpsysadminSupportModuleGenericComponent } from './portal.lpsysadmin.support.module.generic/portal.lpsysadmin.support.module.generic.component';
import { PortalLpsysWidgetBoardComponent } from './portal.lpsys.widget.board/portal.lpsys.widget.board.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalLpsysMyprofileInfoComponent } from './portal.lpsys.myprofile.info/portal.lpsys.myprofile.info.component';
import { PortalLpsysMyprofileEditComponent } from './portal.lpsys.myprofile.edit/portal.lpsys.myprofile.edit.component';
import { PortalLpsysadminWidgetFundInvestmentComponent } from './portal.lpsysadmin.widget.fund.investment/portal.lpsysadmin.widget.fund.investment.component';
import { PortalLpsysadminWidgetNotionCommentsComponent } from './portal.lpsysadmin.widget.notion.comments/portal.lpsysadmin.widget.notion.comments.component';
import { PortalLpsysadminSupportModuleMentoringComponent } from './portal.lpsysadmin.support.module.mentoring/portal.lpsysadmin.support.module.mentoring.component';
import { PortalLpsysadminSupportProgramsComponent } from './portal.lpsysadmin.support.programs/portal.lpsysadmin.support.programs.component';
import { PortalLpsysadminSupportModulesComponent } from './portal.lpsysadmin.support.modules/portal.lpsysadmin.support.modules.component';
import { PortalLpsysadminCollabDashboardComponent } from './portal.lpsysadmin.collab.dashboard/portal.lpsysadmin.collab.dashboard.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PageMyprofileComponent } from './page.myprofile/page.myprofile.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalLpsysadminSupportDashboardComponent } from './portal.lpsysadmin.support.dashboard/portal.lpsysadmin.support.dashboard.component';
import { PageCompanyinfoComponent } from './page.companyinfo/page.companyinfo.component';
import { PortalLpsysadminApprovalListComponent } from './portal.lpsysadmin.approval.list/portal.lpsysadmin.approval.list.component';
import { PortalLpsysadminCollabOrgTreeComponent } from './portal.lpsysadmin.collab.org.tree/portal.lpsysadmin.collab.org.tree.component';
import { PortalLpsysadminFundItemComponent } from './portal.lpsysadmin.fund.item/portal.lpsysadmin.fund.item.component';
import { PortalLpsysadminFundListOperationComponent } from './portal.lpsysadmin.fund.list.operation/portal.lpsysadmin.fund.list.operation.component';
import { PortalLpsysadminWidgetFundMemberComponent } from './portal.lpsysadmin.widget.fund.member/portal.lpsysadmin.widget.fund.member.component';
import { PortalLpsysadminDashboardComponent } from './portal.lpsysadmin.dashboard/portal.lpsysadmin.dashboard.component';
import { PageApplyCompleteComponent } from './page.apply.complete/page.apply.complete.component';
import { PageMyProgramsComponent } from './page.my.programs/page.my.programs.component';
import { PortalLpsysadminWidgetCompanyBoardComponent } from './portal.lpsysadmin.widget.company.board/portal.lpsysadmin.widget.company.board.component';
import { PortalLpsysCommunityBoardComponent } from './portal.lpsys.community.board/portal.lpsys.community.board.component';
import { PortalLpsysadminBusinessManagementComponent } from './portal.lpsysadmin.business.management/portal.lpsysadmin.business.management.component';
import { PortalLpsysWidgetCompanyProductComponent } from './portal.lpsys.widget.company.product/portal.lpsys.widget.company.product.component';
import { PageCompanyReviewComponent } from './page.company.review/page.company.review.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalLpsysWidgetCompanyViewerComponent } from './portal.lpsys.widget.company.viewer/portal.lpsys.widget.company.viewer.component';
import { PortalLpsysadminWidgetNotionEditorComponent } from './portal.lpsysadmin.widget.notion.editor/portal.lpsysadmin.widget.notion.editor.component';
import { PortalLpsysadminFundListFormedComponent } from './portal.lpsysadmin.fund.list.formed/portal.lpsysadmin.fund.list.formed.component';
import { PortalLpsysCompanyItemComponent } from './portal.lpsys.company.item/portal.lpsys.company.item.component';
import { PortalLpsysadminCollabWorkspaceItemComponent } from './portal.lpsysadmin.collab.workspace.item/portal.lpsysadmin.collab.workspace.item.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalLpsysadminWidgetFundMemberSellComponent } from './portal.lpsysadmin.widget.fund.member.sell/portal.lpsysadmin.widget.fund.member.sell.component';
import { PortalLpsysadminSystemDashboardComponent } from './portal.lpsysadmin.system.dashboard/portal.lpsysadmin.system.dashboard.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalLpsysadminWidgetCompanyCommentComponent } from './portal.lpsysadmin.widget.company.comment/portal.lpsysadmin.widget.company.comment.component';
import { PortalLpsysadminPeriodChangeListComponent } from './portal.lpsysadmin.period.change.list/portal.lpsysadmin.period.change.list.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageExitCommitteeComponent } from './page.exit.committee/page.exit.committee.component';
import { PortalLpsysadminOfficialReceiptComponent } from './portal.lpsysadmin.official.receipt/portal.lpsysadmin.official.receipt.component';
import { PortalLpsysadminCollabSearchComponent } from './portal.lpsysadmin.collab.search/portal.lpsysadmin.collab.search.component';
import { PageAttendanceConfirmComponent } from './page.attendance.confirm/page.attendance.confirm.component';
import { PortalLpsysadminCollabDriveComponent } from './portal.lpsysadmin.collab.drive/portal.lpsysadmin.collab.drive.component';
import { PortalLpsysadminWidgetUserProfileComponent } from './portal.lpsysadmin.widget.user.profile/portal.lpsysadmin.widget.user.profile.component';
import { PortalLpsysadminLipsCompanyItemComponent } from './portal.lpsysadmin.lips.company.item/portal.lpsysadmin.lips.company.item.component';
import { PortalLpsysadminSupportAnnouncementsComponent } from './portal.lpsysadmin.support.announcements/portal.lpsysadmin.support.announcements.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalLpsysWidgetFundItemInvestmentComponent } from './portal.lpsys.widget.fund.item.investment/portal.lpsys.widget.fund.item.investment.component';
import { PortalLpsysWidgetFundItemDocsComponent } from './portal.lpsys.widget.fund.item.docs/portal.lpsys.widget.fund.item.docs.component';
import { PortalLpsysadminCompanyListComponent } from './portal.lpsysadmin.company.list/portal.lpsysadmin.company.list.component';
import { PortalLpsysadminSupportSearchComponent } from './portal.lpsysadmin.support.search/portal.lpsysadmin.support.search.component';
import { PortalLpsysadminApprovalTemplateComponent } from './portal.lpsysadmin.approval.template/portal.lpsysadmin.approval.template.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalLpsysadminCollabMemberProfileComponent } from './portal.lpsysadmin.collab.member.profile/portal.lpsysadmin.collab.member.profile.component';
import { PortalLpsysadminWidgetCompanyInfoComponent } from './portal.lpsysadmin.widget.company.info/portal.lpsysadmin.widget.company.info.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PageFundItemComponent } from './page.fund.item/page.fund.item.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalLpsysadminBoardAllComponent } from './portal.lpsysadmin.board.all/portal.lpsysadmin.board.all.component';
import { PortalLpsysadminApprovalItemComponent } from './portal.lpsysadmin.approval.item/portal.lpsysadmin.approval.item.component';
import { PortalLpsysadminTipsCompanyListComponent } from './portal.lpsysadmin.tips.company.list/portal.lpsysadmin.tips.company.list.component';
import { PortalLpsysFundListExitComponent } from './portal.lpsys.fund.list.exit/portal.lpsys.fund.list.exit.component';
import { PortalLpsysadminLipsCompanyListComponent } from './portal.lpsysadmin.lips.company.list/portal.lpsysadmin.lips.company.list.component';
import { PortalLpsysadminTipsCompanyItemComponent } from './portal.lpsysadmin.tips.company.item/portal.lpsysadmin.tips.company.item.component';
import { PortalLpsysadminCollabMeetingListComponent } from './portal.lpsysadmin.collab.meeting.list/portal.lpsysadmin.collab.meeting.list.component';
import { PageCommunityComponent } from './page.community/page.community.component';
import { PortalLpsysadminSupportApplicationsComponent } from './portal.lpsysadmin.support.applications/portal.lpsysadmin.support.applications.component';
import { PortalLpsysadminWidgetFundInviteComponent } from './portal.lpsysadmin.widget.fund.invite/portal.lpsysadmin.widget.fund.invite.component';
import { PortalLpsysadminHrLeaveComponent } from './portal.lpsysadmin.hr.leave/portal.lpsysadmin.hr.leave.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalLpsysadminCashflowComponent } from './portal.lpsysadmin.cashflow/portal.lpsysadmin.cashflow.component';
import { PortalLpsysadminSupportAnnouncementEditorComponent } from './portal.lpsysadmin.support.announcement.editor/portal.lpsysadmin.support.announcement.editor.component';
import { PageApplyFormComponent } from './page.apply.form/page.apply.form.component';
import { PortalLpsysadminWidgetFundDocumentComponent } from './portal.lpsysadmin.widget.fund.document/portal.lpsysadmin.widget.fund.document.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalLpsysWidgetFundItemInfoComponent } from './portal.lpsys.widget.fund.item.info/portal.lpsys.widget.fund.item.info.component';
import { PortalLpsysFundListFormedComponent } from './portal.lpsys.fund.list.formed/portal.lpsys.fund.list.formed.component';
import { PortalLpsysadminTodoComponent } from './portal.lpsysadmin.todo/portal.lpsysadmin.todo.component';
import { PortalLpsysadminBoardItemComponent } from './portal.lpsysadmin.board.item/portal.lpsysadmin.board.item.component';
import { PortalLpsysadminHrAttendanceComponent } from './portal.lpsysadmin.hr.attendance/portal.lpsysadmin.hr.attendance.component';
import { PortalLpsysadminCollabMeetingRoomComponent } from './portal.lpsysadmin.collab.meeting.room/portal.lpsysadmin.collab.meeting.room.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageExpertProgramItemComponent } from './page.expert.program.item/page.expert.program.item.component';
import { PortalLpsysadminHrRecordsComponent } from './portal.lpsysadmin.hr.records/portal.lpsysadmin.hr.records.component';
import { PageCompanyDataComponent } from './page.company.data/page.company.data.component';
import { PortalLpsysadminCalendarComponent } from './portal.lpsysadmin.calendar/portal.lpsysadmin.calendar.component';
import { PortalLpsysadminCollabBoardListComponent } from './portal.lpsysadmin.collab.board.list/portal.lpsysadmin.collab.board.list.component';
import { PortalLpsysadminWidgetCompanyDataComponent } from './portal.lpsysadmin.widget.company.data/portal.lpsysadmin.widget.company.data.component';
import { PageCompanyReportInputComponent } from './page.company.report.input/page.company.report.input.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalLpsysadminWidgetCompanyExitreviewComponent } from './portal.lpsysadmin.widget.company.exitreview/portal.lpsysadmin.widget.company.exitreview.component';
import { PortalLpsysadminUserSignatureComponent } from './portal.lpsysadmin.user.signature/portal.lpsysadmin.user.signature.component';
import { PortalLpsysadminWidgetCompanyReviewComponent } from './portal.lpsysadmin.widget.company.review/portal.lpsysadmin.widget.company.review.component';
import { PageApplyStatusComponent } from './page.apply.status/page.apply.status.component';
import { PagePublicApplyComponent } from './page.public.apply/page.public.apply.component';
import { PortalLpsysadminCollabChatComponent } from './portal.lpsysadmin.collab.chat/portal.lpsysadmin.collab.chat.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalLpsysMyprofilePasswordComponent } from './portal.lpsys.myprofile.password/portal.lpsys.myprofile.password.component';
import { PortalLpsysadminCollabMemberListComponent } from './portal.lpsysadmin.collab.member.list/portal.lpsysadmin.collab.member.list.component';
import { PortalLpsysadminCollabWorkspaceListComponent } from './portal.lpsysadmin.collab.workspace.list/portal.lpsysadmin.collab.workspace.list.component';
import { PortalLpsysadminTipsDashboardComponent } from './portal.lpsysadmin.tips.dashboard/portal.lpsysadmin.tips.dashboard.component';
import { PortalLpsysadminWidgetFundBoardComponent } from './portal.lpsysadmin.widget.fund.board/portal.lpsysadmin.widget.fund.board.component';
import { PortalLpsysadminSupportApplicationItemComponent } from './portal.lpsysadmin.support.application.item/portal.lpsysadmin.support.application.item.component';

var INDEX_PAGE;// = "fund/formed";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "support/apply/:token?",
                component: PageSupportApplyComponent,
                "app_id": "page.support.apply"
            },
            {
                "path": "join",
                component: PageJoinComponent,
                "app_id": "page.join"
            },
            {
                "path": "public/programs",
                component: PagePublicProgramsComponent,
                "app_id": "page.public.programs"
            },
            {
                "path": "logout",
                component: PageLogoutComponent,
                "app_id": "page.logout"
            },
            {
                "path": "findpw",
                component: PageFindpwComponent,
                "app_id": "page.findpw"
            },
            {
                "path": "mentoring/:token?",
                component: PageMentoringSessionComponent,
                "app_id": "page.mentoring.session"
            },
            {
                "path": "investment-committee/:token?",
                component: PageInvestmentCommitteeComponent,
                "app_id": "page.investment.committee"
            },
            {
                "path": "companyinfo/:menu?",
                component: PageCompanyinfoComponent,
                "app_id": "page.companyinfo"
            },
            {
                "path": "company-review/:token?",
                component: PageCompanyReviewComponent,
                "app_id": "page.company.review"
            },
            {
                "path": "exit-committee/:token?",
                component: PageExitCommitteeComponent,
                "app_id": "page.exit.committee"
            },
            {
                "path": "attendance/:token?",
                component: PageAttendanceConfirmComponent,
                "app_id": "page.attendance.confirm"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "company-report-input/:request_id?/:menu?",
                component: PageCompanyReportInputComponent,
                "app_id": "page.company.report.input"
            },
            {
                "path": "public/apply/:program_id?",
                component: PagePublicApplyComponent,
                "app_id": "page.public.apply"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    },
    {
        component: LayoutNavbarComponent,
        "children": [
            {
                "path": "company/:main/:id/:menu",
                component: PageCompanyItemComponent,
                "app_id": "page.company.item"
            },
            {
                "path": "support/manage/:application_id?/:menu?",
                component: PageSupportManageComponent,
                "app_id": "page.support.manage"
            },
            {
                "path": "mentor/:menu?",
                component: PageMentorComponent,
                "app_id": "page.mentor"
            },
            {
                "path": "my/program/:application_id/:tab?",
                component: PageMyProgramItemComponent,
                "app_id": "page.my.program.item"
            },
            {
                "path": "expert/programs/:menu?",
                component: PageExpertProgramsComponent,
                "app_id": "page.expert.programs"
            },
            {
                "path": "myprofile",
                component: PageMyprofileComponent,
                "app_id": "page.myprofile"
            },
            {
                "path": "my/programs",
                component: PageMyProgramsComponent,
                "app_id": "page.my.programs"
            },
            {
                "path": "fund/:status?/:id?/:menu?/:sub?",
                component: PageFundItemComponent,
                "app_id": "page.fund.item"
            },
            {
                "path": "community/:category?/:menu?/:id?",
                component: PageCommunityComponent,
                "app_id": "page.community"
            },
            {
                "path": "expert/program/:program_id/:application_id?",
                component: PageExpertProgramItemComponent,
                "app_id": "page.expert.program.item"
            },
            {
                "path": "company-data/:menu?",
                component: PageCompanyDataComponent,
                "app_id": "page.company.data"
            }
        ]
    },
    {
        component: LayoutApplyComponent,
        "children": [
            {
                "path": "apply",
                component: PageApplyHomeComponent,
                "app_id": "page.apply.home"
            },
            {
                "path": "apply/complete/:no",
                component: PageApplyCompleteComponent,
                "app_id": "page.apply.complete"
            },
            {
                "path": "apply/f/:slug",
                component: PageApplyFormComponent,
                "app_id": "page.apply.form"
            },
            {
                "path": "apply/status",
                component: PageApplyStatusComponent,
                "app_id": "page.apply.status"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "admin/:category?/:main?/:sub?/:id?/:menu?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

INDEX_PAGE = "fund/formed";

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
